import { api } from "@/utils/axiosInterceptor";
import { useMutation, useQuery } from "@tanstack/react-query"

type invitations = {
    userId: string | null,
    userEmail: string | null,
    invitationId: string | null,
    invitationToken: string | null,
    invitationEmail: string | null,
    expiredAt: Date | null,
    status: string | null,
    role: string | null
} 

export const useInvitations = () => {
    const invitationToken = new URLSearchParams(window.location.search).get('token');

    const { 
        data: preprocessingInvitation, 
        isError, 
        isLoading,
        error
    } = useQuery({
        queryKey: ["invitation", invitationToken],
        queryFn: async () => {
            if (!invitationToken) throw new Error("Missing invitation token")

            try {
                const response = await api.get<{ email: string, expiredAt: Date }>(`/invitation/preprocess-invited-member?invitationToken=${invitationToken}`)
                return response.data;
            } catch (error: any) {
                const message = error?.response?.data?.message || "Internal server error. Please try again"
				throw new Error(message);
            }
        }
    })

    const registerInvitedMember = useMutation({
        mutationFn: (data: { email: string, password: string }) =>
            api.post(`/auth/register-invited-member?invitationToken=${invitationToken}`, data)
    })

    const sendInvitationEmail = useMutation({
        mutationFn: (data: { email: string }) =>
            api.post('/invitation', data)
    })

    const {
        data: invitations,
        isLoading: isInvitationsLoading,
        isError: isInvitationsError
    } = useQuery({
        queryKey: ["invitations"],
        queryFn: async () => {
            try {
                const response = await api.get<invitations[]>("/team-members")

                return response.data;
            } catch (error: any) {
                const message = error?.response?.data?.message || "Internal server error. Please try again"
				throw new Error(message);
            }
        }
    })

    const deleteInvitation = useMutation({
        mutationFn: (invitationId: string) =>
            api.delete(`/invitation/${invitationId}`)
    })

    const deleteTeamMember = useMutation({
        mutationFn: (data: { memberId: string, deletionReason: string }) =>
            api.delete(`/team-member`, {data})
    })

    return { 
        preprocessingInvitation,
        isLoading,
        isError,
        error,
        registerInvitedMember: registerInvitedMember.mutateAsync,
        sendInvitationEmail: sendInvitationEmail.mutateAsync,
        invitations,
        isInvitationsLoading,
        isInvitationsError,
        deleteInvitation: deleteInvitation.mutateAsync,
        deleteTeamMember: deleteTeamMember.mutateAsync,
    };
}